import React from 'react';
import {
  CTAButton,
  Description,
  Header,
  HelperText,
  Main,
  Title,
  Wrapper,
} from './StartPage.styles';
import EnterKeySymbol from '../../../img/enter-key-symbol.svg';
import { useIsMobile } from '../../../../_hooks/useIsMobile';
import { useKey } from '../../hooks/useKey';
import { KeyboardShortcut } from '../../Survey.styles';
import { cardAnimationVariants, logoAnimationVariants } from '../../../BeFi20.meta';

interface Props {
  title: string;
  description: string;
  ctaText: string;
  onStartSurvey: () => void;
  logo?: React.ReactNode;
  helperText?: string;
}

export const StartPage = ({
  title,
  description,
  logo,
  helperText,
  ctaText,
  onStartSurvey,
}: Props) => {
  const isMobile = useIsMobile();

  useKey('Enter', onStartSurvey);

  return (
    <Wrapper justifyContent="center" gridGap="56">
      {logo && (
        <Header variants={logoAnimationVariants} initial="enter" animate="visible">
          {logo}
        </Header>
      )}

      <Main variants={cardAnimationVariants} initial="enter" animate="visible">
        <Title as="h1">{title}</Title>

        <Description as="p">{description}</Description>

        {helperText && <HelperText as="p">{helperText}</HelperText>}

        <CTAButton
          size={isMobile ? 'large' : 'medium'}
          onClick={onStartSurvey}
          rightAddon={
            <KeyboardShortcut>
              <EnterKeySymbol width="10" />
            </KeyboardShortcut>
          }
        >
          {ctaText}
        </CTAButton>
      </Main>
    </Wrapper>
  );
};
